import 'react-table/react-table.css';
import {Segment} from 'semantic-ui-react';

import _ from 'lodash';
import React from 'react';
import {Column} from 'react-table';
import * as FuzzyMatch from '../util/fuzzyMatch';
import * as RunHelpers from '../util/runhelpers';
import * as Runs from '../util/runs';

import LegacyWBIcon from './elements/LegacyWBIcon';
import WBReactTable from './WBReactTable';

import '../css/RunConfigTable.less';
import makeComp from '../util/profiler';
import docUrl from '../util/doc_urls';

interface RunConfigTableProps {
  config: any; // Receives raw config (json object)
}

const RunConfigTable: React.FC<RunConfigTableProps> = makeComp(
  ({config}) => {
    const flatConfig = Runs.splitFlatConfig(Runs.flattenConfig(config)).config;
    if (_.keys(flatConfig).length === 0) {
      return (
        <Segment>
          <p>No config parameters saved for this run.</p>
          <p>
            Check the{' '}
            <a target="_blank" rel="noopener noreferrer" href={docUrl.config}>
              configuration documentation
            </a>{' '}
            for more information.
          </p>
        </Segment>
      );
    }
    const keys = _.sortBy(_.keys(flatConfig));
    const rows = _.map(keys, k => {
      const name = Runs.rawConfigKeyDisplayName(k);
      return {
        searchString: name,
        row: {name, key: k},
      };
    });

    const nameColumn: Column = {
      Header: 'Name',
      accessor: 'name',
      className: 'name',
      Cell: cellInfo => (
        <>
          <LegacyWBIcon name="configuration" />
          <span className="name-string">{cellInfo.value}</span>
        </>
      ),
    };

    const valueColumn: Column = {
      Header: 'Value',
      accessor: 'key',
      Cell: cellInfo => (
        <span className="value">
          {RunHelpers.displayValue(flatConfig[cellInfo.value])}
        </span>
      ),
    };

    const columns = [nameColumn, valueColumn];
    const searchResultColumns = (searchQuery: string) => {
      const searchResultNameColumn: Column = {
        Header: 'Name',
        accessor: 'name',
        className: 'name',
        Cell: cellInfo => (
          <>
            <LegacyWBIcon name="configuration" />
            <span className="name-string">
              {FuzzyMatch.fuzzyMatchHighlight(cellInfo.value, searchQuery)}
            </span>
          </>
        ),
      };
      return [searchResultNameColumn, valueColumn];
    };
    return (
      <div className="run-config-table">
        <WBReactTable
          data={rows}
          columns={columns}
          searchResultColumns={searchResultColumns}
          pageSize={20}
        />
      </div>
    );
  },
  {id: 'RunConfigTable', memo: true}
);

export default RunConfigTable;
